document.addEventListener("DOMContentLoaded", function () {
  var item = document.getElementById("hp-nav-item");
  var nav  = document.querySelector(".m-header__navigation");
  if (!item || !nav) return;

  if (!nav.contains(item)) nav.appendChild(item);

  var promo = item.querySelector(".hp-hanging-promo");
  if (!promo) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  promo.classList.add("hp-intro");

  promo.addEventListener("animationend", function (e) {
    if (e.animationName !== "hp-drop") return;
    promo.classList.remove("hp-intro");
    promo.style.animation = "hp-sway 3s ease-in-out infinite";
  }, { once: true });
});